(function() {
  const tabsArray = document.querySelectorAll('.collectionSlider__headerList .collectionSlider__headerListItem');

  document.addEventListener('DOMContentLoaded', function() {
    $('.collectionSlider__products--slider').each(function(index, gallery) {
      $(this).on('init', function (event, slick) {
        changeProgressBar(slick, 0, this);
      })
    });

    $('.collectionSlider__products--slider').each(function() {
      $(this).slick(sliderSettings)
    });

    $('.collectionSlider__products--slider').each(function(index, gallery) {
      $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        changeProgressBar(slick, nextSlide, this);
      })
    });

    toggleVariant();

    tabsArray.forEach(tab => {
      tab.addEventListener('click', (event) => {
        toggleTab(event);
      });
    });

    function toggleTab(e) {
      let currentWrapper = e.currentTarget.closest('.collectionSlider__wrapper'),
          activeTab = currentWrapper.querySelector('.collectionSlider__headerList .active--tab'),
          activeSlider = currentWrapper.querySelector('.collectionSlider__productsWrapper.collectionSlider__productsWrapper--active'),
          currentEvent = e.currentTarget,
          currentSlider = currentWrapper.querySelector(`.collectionSlider__productsWrapper[data-product-slider="${e.currentTarget.dataset.productTag}"]`);

      activeTab.classList.remove('active--tab');
      currentEvent.classList.add('active--tab');
      activeSlider.classList.remove('collectionSlider__productsWrapper--active');
      currentSlider.classList.add('collectionSlider__productsWrapper--active');
    }

    function toggleVariant() {
      let sectionVariants = document.querySelectorAll('.collectionSlider .quick-add__size');

      sectionVariants.forEach(variant => {
        variant.addEventListener('click', (event) => {
          let currentVariant = event.currentTarget,
              currentProduct = currentVariant.closest('.product'),
              currentButtonsArray = currentProduct.querySelectorAll('.collectionFullpageProduct__contentFooterButton span'),
              productActiveTab = currentProduct.querySelector('.quick-add__size--active');

          if (productActiveTab) {
            productActiveTab.classList.remove('quick-add__size--active');
            currentVariant.classList.add('quick-add__size--active');
          } else {
            currentVariant.classList.add('quick-add__size--active');
          }

          currentButtonsArray.forEach(button => {
            button.dataset.id = currentVariant.dataset.id;
            button.dataset.inventoryQuantity = currentVariant.dataset.inventoryQuantity;
          });
        });
      });
    }

    function changeProgressBar(slick, nextSlide, slider) {
      let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100;
      let progressBar = $(slider).next();

      if(window.outerWidth <= 640) {
        calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
      }

      progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
    }
  });
})();
